import PropTypes from 'prop-types'
import React from 'react'
import Article from '../templates/Article'

const EME6609InteractiveVideoPage = props => (
  <Article pathName={props.location.pathname} pageTitle="Interactive Video">
    <section
      aria-labelledby="section-needs-assessment"
      css={css`
        padding-bottom: 5rem;
      `}
    >
      <div className="contain">
        <h1 id="section-needs-assessment">Interactive Video</h1>
        <p>
          I repurposed my EME6208 educational video on polar bears for this
          assignment, and chose to use PlayPosit to add interactivity. I found
          using PlayPosit simple and intuitive, and was able to easily add
          several interactive elements throughout the video, some of which quiz
          the viewer on previously stated facts, while others offer the viewer
          the chance to test their prior knowledge before specific facts are
          presented.
        </p>
        <p>
          While using PlayPosit was simple, I found the integration process with
          Canvas rather difficult and cumbersome. I ended up wasting quite a
          long time trying to link the bulb with my sandbox course, only to
          eventually find that there was a technical issue with the Safari
          browser preventing some type of popup needed to complete the process.
          I was able to solve the issue by switching to a different browser, and
          I believe I have the working properly now as a single assignment in my
          custom course.
        </p>
        <p>
          <a
            href="https://api.playposit.com/player_v2/?type=share&bulb_id=1169453&lms_launch=true"
            target="_blank"
            rel="noopener noreferrer"
          >
            PlayPosit Interactive Video
          </a>
        </p>
      </div>
    </section>
  </Article>
)

EME6609InteractiveVideoPage.propTypes = {
  location: PropTypes.object,
}

export default EME6609InteractiveVideoPage
